var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 292 \\u2013 6",
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-arrow-dropdown"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 569",
    d: "M10.399 23.325a1.362 1.362 0 001.92 0l6.709-6.724a1.356 1.356 0 00.042-1.87l-6.609-6.63a1.355 1.355 0 10-1.92 1.911l5.611 5.7-5.758 5.698a1.356 1.356 0 00.005 1.915z",
    fill: "#3c3c3c"
  }))));
};
export default SvgCaret;